import React from "react";
import { Grid, List, ListItem, Link } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { NavLink } from "react-router-dom";
import Email from "./icons/Email";
import Phone from "./icons/Phone";
import Place from "./icons/Place";
// import { Email as IconEmail, Cellphone as IconMobile, MapMarker as LocationIcon } from "mdi-material-ui";
// import logoUltimateCore from "../../images/ultimatecore-logo.svg";
import logoMt from "../../images/mt-partner-truck.png";

const useStyles = makeStyles((theme) => ({
  footer: {
    background: "linear-gradient(135deg, var(--gray-800) 0%, var(--gray-900) 100%)",
    paddingTop: "4rem",
    paddingBottom: "2rem",
    position: "relative",
    
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "1px",
      background: "linear-gradient(90deg, transparent, var(--accent-teal), transparent)",
    },

    "& img": {
      margin: "1rem 1rem 1rem 0",
      height: "90px",
      filter: "brightness(1.1) drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))",
      transition: "transform 0.3s ease-in-out",
      
      "&:hover": {
        transform: "scale(1.05)",
      },
    },

    "& p": {
      color: "var(--gray-300)",
      fontFamily: "'Inter', sans-serif",
      lineHeight: 1.6,
    },

    "& li, a, b": {
      color: "var(--gray-300)",
      fontSize: "0.9rem",
      textDecoration: "none",
      paddingTop: "0.25rem",
      paddingBottom: "0.25rem",
      marginBottom: "0.5rem",
      fontFamily: "'Inter', sans-serif",
      transition: "color 0.3s ease-in-out",

      "& b": {
        fontWeight: 700,
        fontSize: "1.5rem",
        marginBottom: "1rem",
        color: "white",
        background: "linear-gradient(135deg, var(--accent-teal) 0%, var(--secondary-light) 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
      },
      
      "&:hover": {
        color: "var(--accent-teal)",
        transform: "translateX(5px)",
      },
    },
  },
  
  icon: {
    marginRight: "0.75rem",
    width: "20px",
    height: "20px",
    color: "var(--accent-teal)",
    filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))",
  },
  
  logoContainer: {
    minHeight: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1rem",
    background: "rgba(255, 255, 255, 0.05)",
    borderRadius: "16px",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    transition: "all 0.3s ease-in-out",
    
    "&:hover": {
      background: "rgba(255, 255, 255, 0.08)",
      transform: "translateY(-2px)",
      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
    },
  },
  
  address: {
    paddingBottom: "1rem !important",
    display: "flex",
    alignItems: "flex-start",
    lineHeight: 1.6,
  },
  
  contactItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "0.75rem",
    padding: "0.5rem 0",
    borderRadius: "8px",
    transition: "all 0.3s ease-in-out",
    
    "&:hover": {
      background: "rgba(32, 201, 151, 0.1)",
      transform: "translateX(5px)",
    },
  },
  
  menuItem: {
    position: "relative",
    transition: "all 0.3s ease-in-out",
    
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      bottom: 0,
      width: "0",
      height: "2px",
      background: "var(--accent-teal)",
      transition: "width 0.3s ease-in-out",
    },
    
    "&:hover::before": {
      width: "100%",
    },
  },
  
  sectionTitle: {
    marginBottom: "1.5rem !important",
    position: "relative",
    
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-0.5rem",
      left: 0,
      width: "50px",
      height: "2px",
      background: "linear-gradient(90deg, var(--accent-teal), var(--secondary-light))",
      borderRadius: "2px",
    },
  },
  
  "@media screen and (max-width: 960px)": {
    itemContainer: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      marginBottom: "2rem",
    },
    logoContainer: {
      minHeight: "auto",
      marginBottom: "2rem",
    },
    footer: {
      paddingLeft: "1.5rem",
      paddingRight: "1.5rem",
    },
  },

  bottomContainer: {
    display: "flex",
    marginTop: "2rem",
    paddingTop: "2rem",
    justifyContent: "center",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",

    "& a, p": {
      textDecoration: "none",
      color: "var(--gray-400)",
      fontSize: "0.875rem",
      margin: "0.25rem 1rem",
      fontFamily: "'Inter', sans-serif",
      transition: "color 0.3s ease-in-out",
      
      "&:hover": {
        color: "var(--accent-teal)",
      },
    },
  },

  bottom: {
    background: "linear-gradient(135deg, var(--gray-900) 0%, #000 100%)",
    borderTop: "1px solid rgba(255, 255, 255, 0.05)",
  },

  "@media screen and (max-width: 400px)": {
    footer: {
      paddingLeft: "1rem",
      paddingRight: "1rem",
      
      "& img": {
        margin: "1rem 0",
        height: "70px",
        position: "relative",
      },
    },
    
    logoContainer: {
      padding: "0.75rem",
    },
    
    bottomContainer: {
      flexDirection: "column",
      alignItems: "center",
      
      "& a, p": {
        margin: "0.25rem 0",
      },
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
        className={classes.footer}
      >
        <Grid item xs={12} sm={12} md={11} lg={10}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={4}>
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                className={classes.logoContainer}
              >
                <Grid item>
                  <Link href="https://mtpartner.nl/">
                    <img src={logoMt} alt="logo Mt-Partner"/>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                className={classes.itemContainer}
              >
                <Grid item>
                  <List component="ul">
                    <ListItem className={classes.sectionTitle}>
                      <b>Mt-Partner BV</b>
                    </ListItem>
                    <ListItem className={[classes.address, classes.contactItem].join(" ")}>
                      <Place className={classes.icon} />
                      <div>
                        Herteweide 46<br />
                        5467LE Veghel
                      </div>
                    </ListItem>
                    <ListItem className={classes.contactItem}>
                      <Email className={classes.icon} />
                      <a href="mailto:planning@mt-partner.email">
                        planning@mt-partner.email
                      </a>
                    </ListItem>
                    <ListItem className={classes.contactItem}>
                      <Phone className={classes.icon} />
                      <div>
                        <a href="tel:+31413343240">+31(0) 413 34 32 40</a>
                        <br />
                        <a href="tel:+31622473976">+31(0) 6 22 47 39 76</a>
                      </div>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Grid>
            
            <Grid item xs={12} sm={6} md={4}>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                className={classes.itemContainer}
              >
                <Grid item>
                  <List component="ul">
                    <ListItem className={classes.sectionTitle}>
                      <b>Menu</b>
                    </ListItem>
                    <ListItem className={classes.menuItem}>
                      <NavLink to="/" exact>
                        Home
                      </NavLink>
                    </ListItem>
                    <ListItem className={classes.menuItem}>
                      <NavLink to="/services" exact>
                        Services
                      </NavLink>
                    </ListItem>
                    <ListItem className={classes.menuItem}>
                      <NavLink to="/about-us" exact>
                        Over ons
                      </NavLink>
                    </ListItem>
                    <ListItem className={classes.menuItem}>
                      <NavLink to="/contact" exact>
                        Contact
                      </NavLink>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          
          <Grid container justifyContent="center" className={classes.bottomContainer}>
            <p>© {new Date().getFullYear()} Mt-Partner BV - Alle rechten voorbehouden</p>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

Footer.displayName = "Footer";

export default Footer;
